import React from 'react'

import useReactions from '../../hooks/useReactions'

import './CommentReactionFormatText.scss'

interface CommentReactionFormatTextProps {
  children?: string
  size?: number
}

const CommentReactionFormatText = ({
  children,
  size = 44,
}: CommentReactionFormatTextProps) => {
  const reactions = useReactions()

  if (!children) return <></>

  const match = reactions.find((reaction) => {
    if (children && children.trim) {
      return reaction.colon === children.trim()
    }
    return false
  })

  if (match) {
    return <img src={match.src} alt={match.alt} width={size} height={size} />
  }

  return (
    <p
      className="comment-content-paragraph"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: children }}
    />
  )
}

export default CommentReactionFormatText
